import {isEnabled} from '~/src/utilities/helpers/feature';
import {Feature} from '~/src/utilities/constants/feature';

let scripts = {};

const waitForCondition = (condition, timeout) =>
    new Promise((resolve, reject) => {
        if (condition && condition()) {
            return resolve();
        }

        let cancelTimer = null;
        let conditionTimer = null;

        if (timeout) {
            cancelTimer = setTimeout(() => {
                clearInterval(conditionTimer);
                reject(new Error(`Waiting for condition failed after ${timeout}ms`));
            }, timeout);
        }

        conditionTimer = setInterval(() => {
            if (condition && condition()) {
                cancelTimer && clearTimeout(cancelTimer);
                resolve();
            }
        }, 10);
    });

const loadExternalDependency = ({src, async = true}) => {
    if (!scripts[src]) {
        scripts[src] = new Promise((resolve, reject) => {
            if (!isEnabled(Feature.EXTERNAL_DEPENDENCIES)) {
                return resolve();
            }

            const script = document.createElement('script');

            script.onload = () => {
                resolve();
            };

            script.onerror = () => {
                reject(new Error(`Failed to load script ${src}`));
            };

            script.src = src;
            script.async = async;
            document.body.appendChild(script);
        });
    }

    return scripts[src];
};

export {waitForCondition, loadExternalDependency};
